import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./components/auth/AuthContext";

// Layout
import Layout from "./components/common/Layout";

// Auth pages
import SignIn from "./components/auth/SignIn";
import Auth404 from "./components/auth/Auth404";
import Auth403 from "./components/auth/Auth403";
import Auth500 from "./components/auth/Auth500";
import AccountSetting from "./components/pages/account/AccountSetting";

import { AbilityProvider } from "./components/context/AbilityContext";

import Crm from "./components/pages/crm/Crm";
import Notfound from "./components/pages/Notfound";
import {
  PrivateRoutes,
  PublicRoutes,
} from "./components/middleware/RouteMiddeware";

//yobas
import AddUser from "./components/pages/yobas/user/AddUser";
import UserList from "./components/pages/yobas/user/UserList";
import AddWearhouse from "./components/pages/yobas/wearhouse/AddWearhouse";
import WearhouseList from "./components/pages/yobas/wearhouse/WearhouseList";
import AddProduct from "./components/pages/yobas/product/AddProduct";
import ProductList from "./components/pages/yobas/product/ProductList";
import UploadLabel from "./components/pages/yobas/label/UploadLabel";
import ViewLabel from "./components/pages/yobas/label/ViewLabel";
import ApproveWorkflow from "./components/pages/yobas/worflow/AproveWorkflow";
import ViewTracking from "./components/pages/yobas/tracking/ViewTracking";
import AssignProduct from "./components/pages/yobas/assignProduct/AssignProduct";
import LabelList from "./components/pages/yobas/label/LabelList";
import TrackingList from "./components/pages/yobas/tracking/TrackingList";
import Invoice from "./components/pages/yobas/invoice/Invoice";
import Pricing from "./components/pages/yobas/pricing/Pricing";
import ShipmentInvoice from "./components/pages/yobas/invoice/ShipmentInvoice";
import Leasure from "./components/pages/yobas/invoice/Leasure";
import AssignProductList from "./components/pages/yobas/assignProduct/AssignProductList";
import ViewInvoice from "./components/pages/yobas/invoice/ViewInvoice";
import ContactList from "./components/pages/yobas/contact/ContactList";
import ServiceList from "./components/pages/yobas/services/ServicesList";
import AddServices from "./components/pages/yobas/services/AddServices";
import LeasureList from "./components/pages/yobas/invoice/LeasureList";
import ViewWorkflow from "./components/pages/yobas/worflow/ViewWorkflow";
import WarehouseProducts from "./components/pages/yobas/wearhouse/WarehouseProducts";
import OrderList from "./components/pages/yobas/order/OrderList";
import AddOrder from "./components/pages/yobas/order/AddOrder";
import AddHero from "./components/pages/yobas/addHero/AddHero";
import HeroList from "./components/pages/yobas/addHero/HeroList";
import ProductLogs from "./components/pages/yobas/logs/ProductLogs";
import Cost from "./components/pages/yobas/pricing/Cost";
import AddPackage from "./components/pages/yobas/addPackages/AddPackage";
import PackageList from "./components/pages/yobas/addPackages/PackageList";
import ShipmentLeasure from "./components/pages/yobas/invoice/ShipmentLeasure";

const App = () => {
  const routerBase =
    process.env.PUBLIC_URL && process.env.PUBLIC_URL !== "."
      ? process.env.PUBLIC_URL
      : undefined;

  return (
    <AbilityProvider>
      <AuthProvider>
        <BrowserRouter basename={routerBase}>
          <Routes>
            {/* Auth routes without layout */}
            <Route element={<PublicRoutes />}>
              <Route path="/auth-signin" element={<SignIn />} />
              {/* <Route path="/auth-signup" element={<SignUp />} /> */}
              {/* <Route path="/auth-password-reset" element={<AuthReset />} /> */}
              {/* <Route path="/auth-reset" element={<AuthReset />} /> */}
              {/* <Route path="/auth-two-step" element={<AuthTwoStep />} /> */}
              {/* <Route path="/auth-lockscreen" element={<AuthLockscreen />} /> */}
              {/* <Route path="/auth-maintenance" element={<AuthMaintenance />} /> */}
              <Route path="/auth-404" element={<Auth404 />} />
              <Route path="/auth-403" element={<Auth403 />} />
              <Route path="/auth-500" element={<Auth500 />} />
              <Route path="/leasure-list-member" element={<Leasure />} />
              <Route path="leasure-list-detail-member/:id" element={<LeasureList />} />
            </Route>

            {/* All protected routes with layout */}
            <Route element={<PrivateRoutes />}>
              <Route path="/" element={<Layout />}>
                <Route path="/" element={<Crm />} />
                <Route path="user-add" element={<AddUser />} />
                <Route path="user-update/:id" element={<AddUser />} />
                <Route path="user-list" element={<UserList />} />
                <Route path="warehouse-add" element={<AddWearhouse />} />
                <Route path="warehouse-update/:id" element={<AddWearhouse />} />
                <Route path="warehouse-products/:id" element={<WarehouseProducts />} />
                <Route path="warehouse-list" element={<WearhouseList />} />
                <Route path="product-add" element={<AddProduct />} />
                <Route path="product-update/:id" element={<AddProduct />} />
                <Route path="product-list" element={<ProductList />} />
                <Route path="label-upload" element={<UploadLabel />} />
                <Route path="label-view" element={<ViewLabel />} />
                <Route path="label-list/:date" element={<LabelList />} />
                <Route path="workflow-view" element={<ViewWorkflow />} />
                <Route path="workflow-list/:date" element={<ApproveWorkflow />} />
                <Route path="tracking-view" element={<ViewTracking />} />
                <Route path="tracking-list/:date" element={<TrackingList />} />
                <Route path="assign-product" element={<AssignProduct />} />
                <Route path="assign-product/:id" element={<AssignProduct />} />
                <Route path="assign-product-list" element={<AssignProductList />} />
                <Route path="mega-folder" element={<AssignProduct />} />
                <Route path="memember-mega-folder" element={<AssignProduct />} />
                <Route path="calculation-view" element={<ViewInvoice />} />
                <Route path="calculation-list/:id" element={<Invoice />} />
                <Route path="leasure-list" element={<Leasure />} />
                <Route path="leasure-list-detail/:id" element={<LeasureList />} />
                <Route path="warehouse-calculation-daytoday" element={<ShipmentInvoice />} />
                <Route path="set-pricing" element={<Pricing />} />
                <Route path="service-add" element={<AddServices />} />
                <Route path="service-update/:id" element={<AddServices />} />
                <Route path="services-list" element={<ServiceList />} />
                <Route path="contact-list" element={<ContactList />} />
                <Route path="order-add" element={<AddOrder />} />
                <Route path="order-list" element={<OrderList />} />
                <Route path="hero-add" element={<AddHero />} />
                <Route path="hero-update/:id" element={<AddHero />} />
                <Route path="hero-list" element={<HeroList />} />
                <Route path="product-log-list" element={<ProductLogs />} />
                <Route path="shipmnet-cost" element={<Cost />} />
                <Route path="package-add" element={<AddPackage />} />
                <Route path="package-update/:id" element={<AddPackage />} />
                <Route path="packages-list" element={<PackageList />} />
                <Route path="shipment-leasure/:id" element={<ShipmentLeasure />} />

                <Route path="/account-settings" element={<AccountSetting />} />
                <Route path="*" element={<Notfound />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </AbilityProvider>
  );
};

export default App;
